import L from 'leaflet';
import { isEmpty, forEach, get } from 'lodash';

import { usToDDHHMMSS } from '../dates';

const Z_INDEX = 2000;

/**
 * Draws the video control points in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object[]} arg.controlPoints - The video control points.
 * @param {?object} arg.controlPointsLayer - The geoJSON layer where the control points will be painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {boolean} [arg.onClickControlPoint] - Function to run when clicking on control point.
 * @returns {object} The leaflet layer where the control points are painted.
 */
const drawVideoControlPoints = ({
  leafletMap,
  controlPoints,
  controlPointsLayer,
  isUpdate = false,
  onClickControlPoint = () => {}
}) => {
  let newControlPointsLayerContainer = '';

  if (!isUpdate) {
    newControlPointsLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newControlPointsLayerContainer = controlPointsLayer;
    newControlPointsLayerContainer.clearLayers();
  }

  if (!isEmpty(controlPoints)) {
    forEach(controlPoints.features, (controlPoint, index, array) => {
      const timeUS = get(controlPoint, 'properties.timeUS');
      const myControlPointLayer = L.geoJSON(controlPoint);
      newControlPointsLayerContainer.addLayer(
        myControlPointLayer
          .getLayers()[0]
          .setZIndexOffset(Z_INDEX)
          .bindPopup(`Control Point at ${usToDDHHMMSS(timeUS)}`)
          .on('click', () => {
            if (index !== 0 && index !== array.length - 1)
              onClickControlPoint({ controlPoint, controlPointTime: timeUS });
          })
          .on('mouseover', () => myControlPointLayer.getLayers()[0].openPopup())
          .on('mouseout', () => myControlPointLayer.getLayers()[0].closePopup())
      );
    });
  }
  return newControlPointsLayerContainer;
};

export default drawVideoControlPoints;
